import { useDispatch } from 'react-redux'
import styles from './popups.module.css'
import { removeVendorFromKazoo } from '../../features/vendorSlice.js'
import { ViewProfileRedirect } from './ViewProfileRedirect'
import CommonDeleteModal from '../atoms/modal/CommonDeleteModal'
import ButtonCustom from '../atoms/button/ButtonCustom'

export const RemoveKazooVendorPopup = ({
	clickHandler,
	vendor = {},
	kazooId,
	removingVendor = false,
}) => {
	const dispatch = useDispatch()

	const hasVendorId = Boolean(vendor?._id)

	const handleRemove = () => {
		dispatch(
			removeVendorFromKazoo({
				vendorId: vendor?._id,
				kazooId,
				email: vendor?.email,
			})
		) // Remove the vendor using their unique _id
		clickHandler() // Close the popup after the action
	}

	const headingContent = (
		<>
			Would you like to remove{' '}
			{hasVendorId ? (
				<ViewProfileRedirect
					id={vendor._id}
					name={vendor?.businessName}
				/>
			) : (
				<span>{vendor?.email}</span>
			)}{' '}
			from the wedding?
		</>
	)

	return (
		<CommonDeleteModal
			open={removingVendor}
			handleClose={clickHandler}
			heading={headingContent}
			className={styles.deleteModal}
			ClassIcon={styles.detailModalIcon}
			footerContent={
				<>
					<ButtonCustom
						variant="outlined"
						type="button"
						size="lg"
						onClick={clickHandler}
					>
						Cancel
					</ButtonCustom>
					<ButtonCustom
						variant="destructive"
						size="lg"
						onClick={handleRemove}
					>
						Remove
					</ButtonCustom>
				</>
			}
		></CommonDeleteModal>
	)
}
